import { Component } from 'react';

class Account extends Component {
  render() {
    return (
      <div className="home-wrapper d-flex align-items-center justify-content-center flex-column mt-10">
        <div className={'mb-3'}>It's the job that's never started as takes longest to finish.</div>

        <div>( ಠ ಠ )</div>
      </div>
    );
  }
}

export default Account;
